const home = document.getElementById('home');

// if (home) {
//   jQuery(document).ready((function(e){e("#burger_nav").click((function(){e(this).toggleClass("open"),e(".mobile-menu").toggleClass("open"),e("body").toggleClass("no-scroll")}));let t=document.getElementsByClassName("advocacy-actionwidget");e(t).css({"shadow-box":"none !important",border:"none !important"});const n=1e3,o=6e4,l=36e5,a=24*l;let s=new Date("Mar 25, 2021 00:00:00").getTime();setInterval((function(){let e=(new Date).getTime(),t=s-e;document.getElementById("days").innerText=Math.floor(t/a),document.getElementById("hours").innerText=Math.floor(t%a/l),document.getElementById("minutes").innerText=Math.floor(t%l/o),document.getElementById("seconds").innerText=Math.floor(t%o/n)}),n)}));
// }

jQuery(document).ready(function($){

    new Glider(document.querySelector('.glider'), {
        // Mobile-first defaults
        slidesToShow: 1,
        slidesToScroll: 1,
        scrollLock: true,
        arrows: {
          prev: '.glider-prev',
          next: '.glider-next'
        },
        responsive: [
          {
            // screens greater than >= 775px
            breakpoint: 775,
            settings: {
              // Set to `auto` and provide item width to adjust to viewport
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          }
        ]
      });

      let viewWidth = $(window).width();

      if (viewWidth > 768) {
        let slide = document.getElementsByClassName('slide-content');
        let excerpt = document.getElementsByClassName('excerpt');

        for (let i = 0; i < slide.length; i++) {
            $(slide[i]).hover(
                () => {
                    $(excerpt[i]).slideToggle();
                }, () => {
                    $(excerpt[i]).slideToggle();
            });
        }
      }

      let learnMoreBtn = document.getElementsByClassName('learn-more-btn');
      let shadowbox = document.getElementsByClassName('shadowbox');
      let shadowboxExit = document.getElementsByClassName('shadowbox-exit');
      let shadowboxBg = document.getElementsByClassName('shadowbox-bg');

      for (let i = 0; i < shadowbox.length; i++) {

        $(learnMoreBtn[i]).click(() => {
            $(shadowbox[i]).fadeIn(500);
        });
        $(shadowboxBg[i]).click(() => {
            $(shadowbox[i]).fadeOut(500);
        });
        $(shadowboxExit[i]).click(() => {
            $(shadowbox[i]).fadeOut(500);
        });
      }

});